import { render, staticRenderFns } from "./IconMessenger.vue?vue&type=template&id=173c7b60"
import script from "./IconMessenger.vue?vue&type=script&lang=js"
export * from "./IconMessenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports